// Taken from https://stackoverflow.com/a/41429145/2247097
export class ClientNotInitializedError extends Error {
    constructor() {
        super();
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ClientNotInitializedError.prototype);
    }
}
export class Web3ModalError extends Error {
    constructor(message) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, Web3ModalError.prototype);
    }
}
//# sourceMappingURL=errors.js.map